import {ActionCreatorDefinition, createAction} from "redux-ts";
import {TSMap} from "typescript-map";
import {Lesson, TutorialCategory} from "protocol/config/GetUIConfigurationResponse";
import {
    LDAcademyVideo,
    LDAcademyVideoGroup,
    LDAppCuesWalkThrough,
    LDAppCuesWalkThroughGroup
} from "core/props/LDPlatformProps";

export const FetchUIConfigurationType: string = "FetchUIConfiguration";
export const SetLDAcademyConfigurationType: string = "SetLDAcademyConfiguration";
export const SetLessonsType: string = "SetLessons";
export const OptInLessonType: string = "OptInLesson";
export const SetLessonType: string = "SetLesson";
export const RequestEnableEbookType: string = "RequestEnableEbook";
export const ConfirmRequestEnableLearningCenterType: string = "ConfirmRequestEnableLearningCenter";
export const RequestExtendTutorialsType: string = "RequestExtendTutorials";
export const SetAcademyVideoType: string = "SetAcademyVideoType";

export interface SetLessonsPayload {

    categories: TutorialCategory[];
    lessons: TSMap<number, Lesson[]>;
    LearningCenterExpiration: number;
    EbookUrl: string;
}

export interface SetLDAcademyConfigurationPayload {

    walkThroughGroups: LDAppCuesWalkThroughGroup[];
    walkThrough: TSMap<number, LDAppCuesWalkThrough[]>;
    academyVideoGroups: LDAcademyVideoGroup[];
    academyVideos: TSMap<number, LDAcademyVideo[]>;
    supportZendesk: {[key: string]: string};
}

export interface OptInLessonPayload {

    lesson: Lesson;
}

export interface SetLessonPayload {

    lesson: Lesson;
}

export interface SetAcademyVideoPayload {

    video: LDAcademyVideo;
}

export const FetchUIConfiguration: ActionCreatorDefinition<any, any> = createAction<any>(FetchUIConfigurationType);
export const SetLDAcademyConfiguration: ActionCreatorDefinition<SetLDAcademyConfigurationPayload, any> = createAction<SetLDAcademyConfigurationPayload>(SetLDAcademyConfigurationType);
export const SetLessons: ActionCreatorDefinition<SetLessonsPayload, any> = createAction<SetLessonsPayload>(SetLessonsType);
export const OptInLesson: ActionCreatorDefinition<OptInLessonPayload, any> = createAction<OptInLessonPayload>(OptInLessonType);
export const SetLesson: ActionCreatorDefinition<SetLessonPayload, any> = createAction<SetLessonPayload>(SetLessonType);
export const SetAcademyVideo: ActionCreatorDefinition<SetAcademyVideoPayload, any> = createAction<SetAcademyVideoPayload>(SetAcademyVideoType);
export const RequestEnableEbook: ActionCreatorDefinition<any, any> = createAction<any>(RequestEnableEbookType);
export const ConfirmRequestEnableLearningCenter: ActionCreatorDefinition<any, any> = createAction<any>(ConfirmRequestEnableLearningCenterType);
export const RequestExtendTutorials: ActionCreatorDefinition<any, any> = createAction<any>(RequestExtendTutorialsType);
